module.exports = __webpack_public_path__ + "606f9fd8e3b88873023392b698e8c45c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/history/fi-1997.png
// module id = 407
// module chunks = 0